import { ECustomDateColumnType } from './custom-date-columns.model';

export interface DateColumnsListItem {
    displayName: string;
    eCustomDateColumnType: ECustomDateColumnType;
    selected: boolean;
    type: 'Shamsi' | 'Miladi';
    sample: string;
    columnDisplayName: string;
    columnNameSuffix: string;
    disabled: boolean;
}

export const shamsiDateColumnTypes: DateColumnsListItem[] = [
    // all the Shamsi dates
    {
        displayName:'تاریخ شمسی',
        eCustomDateColumnType:'DateTime',
        type:'Shamsi' ,
        selected: false,
        sample:'12/3/1403',
        columnDisplayName:'S1'  ,
        columnNameSuffix:'Jalali',
        disabled:false },
    {
        displayName:'سال شمسی',
        eCustomDateColumnType:'Year',
        type:'Shamsi' ,
        selected: false,
        sample:'1403',
        columnDisplayName:'S2'  ,
        columnNameSuffix:'J_Year',
        disabled:false },
    {
        displayName:'نیمه شمسی',
        eCustomDateColumnType:'HalfYear',
        type:'Shamsi' ,
        selected: false,
        sample:'2',
        columnDisplayName:'S3'  ,
        columnNameSuffix:'J_MidYear',
        disabled:false },
    {
        displayName:'نیمه شمسی (متنی)',
        eCustomDateColumnType:'HalfYearText',
        type:'Shamsi' ,
        selected: false,
        sample:'نیمه ی دوم سال',
        columnDisplayName:'S4'  ,
        columnNameSuffix:'J_MidYear_T',
        disabled:false },
    {
        displayName:'فصل شمسی',
        eCustomDateColumnType:'Season',
        type:'Shamsi' ,
        selected: false,
        sample:'4',
        columnDisplayName:'S5'  ,
        columnNameSuffix:'J_Quarter',
        disabled:false },
    {
        displayName:'فصل شمسی (متنی)',
        eCustomDateColumnType:'SeasonText',
        type:'Shamsi' ,
        selected: false,
        sample:'زمستان',
        columnDisplayName:'S6'  ,
        columnNameSuffix:'J_Quarter_T',
        disabled:false },
    {
        displayName:'ماه شمسی',
        eCustomDateColumnType:'Month',
        type:'Shamsi' ,
        selected: false,
        sample:'12',
        columnDisplayName:'S7'  ,
        columnNameSuffix:'J_Month',
        disabled:false },
    {
        displayName:'ماه شمسی (متنی)',
        eCustomDateColumnType:'MonthText',
        type:'Shamsi' ,
        selected: false,
        sample:'اسفند',
        columnDisplayName:'S8'  ,
        columnNameSuffix:'J_Month_T',
        disabled:false },
    {
        displayName:'هفته شمسی',
        eCustomDateColumnType:'Week',
        type:'Shamsi' ,
        selected: false,
        sample:'52',
        columnDisplayName:'S9'  ,
        columnNameSuffix:'J_Week',
        disabled:false },
    // {
    //     displayName:'هفته در ماه شمسی',
    //     eCustomDateColumnType:'WeekOfMonth',
    //     type:'Shamsi' ,
    //     selected: false,
    //     sample:'4',
    //     columnDisplayName:'S10' ,
    //     columnNameSuffix:'J_WeekMonth',
    //     disabled:false },
    // {
    //     displayName:'هفته شمسی (متنی)',
    //     eCustomDateColumnType:'WeekOfMonthText',
    //     type:'Shamsi' ,
    //     selected: false,
    //     sample:'هفته چهارم ماه',
    //     columnDisplayName:'S11' ,
    //     columnNameSuffix:'J_WeekMonth_T',
    //     disabled:false },
    {
        displayName:'روز شمسی',
        eCustomDateColumnType:'Day',
        type:'Shamsi' ,
        selected: false,
        sample:'21',
        columnDisplayName:'S12' ,
        columnNameSuffix:'J_Day',
        disabled:false },
    {
        displayName:'روز در هفته شمسی',
        eCustomDateColumnType:'DayOfWeek',
        type:'Shamsi' ,
        selected: false,
        sample:'3',
        columnDisplayName:'S13' ,
        columnNameSuffix:'J_WeekDay',
        disabled:false },
    {
        displayName:'روز شمسی (متنی)',
        eCustomDateColumnType:'DayOfWeekText',
        type:'Shamsi' ,
        selected: false,
        sample:'دوشنبه',
        columnDisplayName:'S14' ,
        columnNameSuffix:'J_WeekDay_T',
        disabled:false },
    ];

export const miladiDateColumnTypes: DateColumnsListItem[] =[
    // Miladi dates
    {
        displayName:'تاریخ میلادی',
        eCustomDateColumnType:'DateTime',
        type:'Miladi' ,
        selected: false,
        sample:'12/3/1996',
        columnDisplayName:'M1'  ,
        columnNameSuffix:'Miladi',
        disabled:false },
    {
        displayName:'سال میلادی',
        eCustomDateColumnType:'Year',
        type:'Miladi' ,
        selected: false,
        sample:'2023',
        columnDisplayName:'M2'  ,
        columnNameSuffix:'M_Year',
        disabled:false },
    {
        displayName:'نیمه میلادی',
        eCustomDateColumnType:'HalfYear',
        type:'Miladi' ,
        selected: false,
        sample:'2',
        columnDisplayName:'M3'  ,
        columnNameSuffix:'M_MidYear',
        disabled:false },
    {
        displayName:'نیمه میلادی (متنی)',
        eCustomDateColumnType:'HalfYearText',
        type:'Miladi' ,
        selected: false,
        sample:'First Half of Year',
        columnDisplayName:'M4'  ,
        columnNameSuffix:'M_MidYear_T',
        disabled:false },
    {
        displayName:'فصل میلادی',
        eCustomDateColumnType:'Season',
        type:'Miladi' ,
        selected: false,
        sample:'4',
        columnDisplayName:'M5'  ,
        columnNameSuffix:'M_Quarter',
        disabled:false },
    {
        displayName:'فصل میلادی (متنی)',
        eCustomDateColumnType:'SeasonText',
        type:'Miladi' ,
        selected: false,
        sample:'Winter',
        columnDisplayName:'M6'  ,
        columnNameSuffix:'M_Quarter_T',
        disabled:false },
    {
        displayName:'ماه میلادی',
        eCustomDateColumnType:'Month',
        type:'Miladi' ,
        selected: false,
        sample:'03',
        columnDisplayName:'M7'  ,
        columnNameSuffix:'M_Month',
        disabled:false },
    {
        displayName:'ماه میلادی (متنی)',
        eCustomDateColumnType:'MonthText',
        type:'Miladi' ,
        selected: false,
        sample:'March',
        columnDisplayName:'M8'  ,
        columnNameSuffix:'M_Month_T',
        disabled:false },
    {
        displayName:'هفته میلادی',
        eCustomDateColumnType:'Week',
        type:'Miladi' ,
        selected: false,
        sample:'52',
        columnDisplayName:'M9'  ,
        columnNameSuffix:'M_Week',
        disabled:false },
    // {
    //     displayName:'هفته در ماه میلادی',
    //     eCustomDateColumnType:'WeekOfMonth',
    //     type:'Miladi' ,
    //     selected: false,
    //     sample:'4',
    //     columnDisplayName:'M10' ,
    //     columnNameSuffix:'M_WeekMonth',
    //     disabled:false },
    // {
    //     displayName:'هفته میلادی (متنی)',
    //     eCustomDateColumnType:'WeekOfMonthText',
    //     type:'Miladi' ,
    //     selected: false,
    //     sample:'هفته چهارم ماه',
    //     columnDisplayName:'M11' ,
    //     columnNameSuffix:'M_WeekMonth_T',
    //     disabled:false },
    {
        displayName:'روز میلادی',
        eCustomDateColumnType:'Day',
        type:'Miladi' ,
        selected: false,
        sample:'21',
        columnDisplayName:'M12' ,
        columnNameSuffix:'M_Day',
        disabled:false },
    {
        displayName:'روز در هفته میلادی',
        eCustomDateColumnType:'DayOfWeek',
        type:'Miladi' ,
        selected: false,
        sample:'3',
        columnDisplayName:'M13' ,
        columnNameSuffix:'M_WeekDay',
        disabled:false },
    {
        displayName:'روز میلادی (متنی)',
        eCustomDateColumnType:'DayOfWeekText',
        type:'Miladi' ,
        selected: false,
        sample:'Monday',
        columnDisplayName:'M14' ,
        columnNameSuffix:'M_WeekDay_T',
        disabled:false },

  ];
